import { IStage, StageShape } from '../../models/Stage';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: IStage = {
	shape: StageShape.Rectangle,
	size: { x: 1000, y: 500 },
};

const reducer = (state: IStage = initialState, action: Action): IStage => {
	switch (action.type) {
		case ActionType.SET_STAGE_SHAPE: {
			return {
				...state,
				shape: action.payload.shape,
			};
		}
		case ActionType.SET_STAGE_SIZE: {
			return {
				...state,
				size: action.payload.size,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};

export default reducer;
